import { alpha, Theme } from '@mui/material';

export default {
    field: {
        input: {
            color: (theme: Theme) => theme.palette.text.primary,
            '&:hover': {
                cursor: 'pointer',
            },
        },
    },
    previewColor: {
        width: '16px',
        height: '16px',
        ml: 1,
        mr: '-6px',
        flexShrink: 0,
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.16)}`,
        '.design-variant--secondary &': {
            ml: '6px',
            mr: '-2px',
            borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.24),
            borderRadius: '1px',
        },
    },
    pickerIcon: {
        flexShrink: 0,
        flexDirection: 'row',
        alignItem: 'center',
        pr: '6px',
        cursor: 'pointer',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.64),
        '.Mui-focused &, .MuiInput-root:hover &': {
            color: (theme: Theme) => theme.palette.primary.main,
        },
    },
    colorPickerWrapper: {
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.16)}`,
        borderRadius: 1,
        backgroundColor: 'background.default',
        '.colorPickerPlugin': {
            backgroundColor: 'transparent !important',
            borderRadius: '0 !important',
            boxShadow: 'none !important',
        },
        '.colorPickerPlugin--compact .flexbox-fix': {
            display: 'none !important',
        },
        //hide component extra wrapper
        '&>div[style*=inline-block]>div[style*=absolute]': {
            display: 'none !important',
        },
    },
    colorPickerResetWrap: {
        textAlign: 'center',
        pt: 0.5,
        pb: 1,
    },
    colorPickerReset: {
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: '14px',
        '&:hover': {
            cursor: 'pointer',
            textDecoration: 'none',
            opacity: '0.75',
        },
    },
};
